import { render, staticRenderFns } from "./categories.component.vue?vue&type=template&id=028c8384&scoped=true&"
import script from "./categories.component.vue?vue&type=script&lang=js&"
export * from "./categories.component.vue?vue&type=script&lang=js&"
import style0 from "./categories.component.vue?vue&type=style&index=0&id=028c8384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c8384",
  null
  
)

export default component.exports